<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('订单历史.订单历史')" class="nav-bar">
      <template #left>
        <img src="/img/common/icon-back.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('订单历史.数据为空')" />
        <template v-else>
          <div class="item_list" v-for="(order, key) in list" :key="key">

            <!-- 订单头部信息 -->
            <div class="order-header">
              <div class="order-id">
                <span class="label">{{ $t('订单历史.订单号') }}</span>
                <span class="value">{{ order.id }}</span>
              </div>
              <div class="order-status">
                <span v-if="order.status === 1" class="status-success">{{ $t('订单历史.已完成') }}</span>
                <span v-else-if="order.status === 2" class="status-pending">{{ $t('订单历史.处理中') }}</span>
                <span v-else>
                  <button
                    class="complete-order-btn-inline"
                    @click="openOrderModal(order)"
                    :disabled="orderLoading"
                  >
                    {{ $t('订单历史.完成订单') }}
                  </button>
                </span>
              </div>
            </div>

            <!-- 金额信息 -->
            <div class="amount-info">
              <div class="amount-row">
                <span class="label">{{ $t('订单历史.订单金额') }}</span>
                <span class="value">${{ order.total_amount }}</span>
              </div>
              <div class="amount-row">
                <span class="label">{{ $t('订单历史.佣金') }}</span>
                <span class="value commission">${{ order.commission }}</span>
              </div>
            </div>

            <!-- 时间信息 -->
            <div class="time-info">
              <div class="time-row">
                <span class="label">{{ $t('订单历史.创建时间') }}</span>
                <span class="value">{{ formatTime(order.create_at) }}</span>
              </div>
            </div>

          </div>
        </template>
      </van-pull-refresh>

      <!-- 分页 -->
      <div class="pagination" v-if="totalPages > 1 || list.length > limit">
        <van-button
          :disabled="currentPage === 1"
          @click="changePage(currentPage - 1)"
          class="page-btn"
        >
          {{ $t('订单历史.上一页') }}
        </van-button>
        <span class="page-info">{{ `${currentPage} / ${totalPages}` }}</span>
        <van-button
          :disabled="currentPage === totalPages"
          @click="changePage(currentPage + 1)"
          class="page-btn"
        >
          {{ $t('订单历史.下一页') }}
        </van-button>
      </div>
    </div>

    <LuckyOrderIntro
      :visible="showLuckyIntro"
      :commission="luckyCommission"
      @done="onLuckyIntroDone"
    />

    <div v-if="showOrderModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ $t('抢单.提交订单') }}</h3>
          <button class="close-btn" @click="closeModal" :disabled="orderLoading">&times;</button>
        </div>

        <div class="modal-body" v-if="currentOrder">
          <div class="order-info">
            <div class="order-time">
              <span class="time-label">{{ $t('抢单.抢单时间') }}</span>
              <span class="time-value">{{ formatTime(currentOrder.create_at) }}</span>
            </div>
            <div class="order-number">
              <span class="number-label">{{ $t('抢单.订单号') }}</span>
              <span class="number-value">{{ currentOrder.id }}</span>
            </div>
            <div class="goods-card">
              <div v-if="currentOrder.goods_pic" class="goods-image-section">
                <img
                  :src="currentOrder.goods_pic"
                  :alt="currentOrder.goods_name"
                  class="goods-image"
                  @error="handleImageError"
                />
              </div>
              <div class="goods-info-section">
                <div class="goods-name">{{ currentOrder.goods_name || '-' }}</div>
              </div>
            </div>
            <div class="amount-summary">
              <div class="modal-amount-row">
                <div class="amount-item">
                  <span class="amount-label">{{ $t('抢单.订单总额') }}</span>
                  <span class="amount-value">{{ currentOrder.total_amount || currentOrder.goods_price }}</span>
                </div>
                <div class="amount-item">
                  <span class="amount-label">{{ $t('抢单.佣金') }}</span>
                  <span class="commission-value">{{ currentOrder.commission }}</span>
                </div>
                <div class="amount-item" v-if="showOrderShortfall">
                  <span class="amount-label">{{ $t('抢单.当前余额') }}</span>
                  <span class="amount-value">{{ displayBalance }}</span>
                </div>
                <div class="amount-item" v-if="showOrderShortfall">
                  <span class="amount-label">{{ $t('抢单.还需缴纳') }}</span>
                  <span class="shortfall-value">{{ orderShortfall }}</span>
                </div>
              </div>
            </div>
            <div class="pay-password-wrap" v-if="needPayPasswordInput">
              <input
                v-model="paypassword"
                type="password"
                class="pay-password-input"
                :placeholder="$t('订单历史.请输入支付密码')"
                autocomplete="off"
                :disabled="orderLoading"
              />
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="cancel-btn" @click="closeModal" :disabled="orderLoading">
            {{ $t('抢单.取消') }}
          </button>
          <button
            class="place-order-btn"
            @click="confirmPlaceOrder"
            :disabled="!currentOrder || orderLoading"
          >
            <span v-if="orderLoading">{{ $t('抢单.支付处理中') }}</span>
            <span v-else>{{ $t('抢单.确认付款') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'
import LuckyOrderIntro from '@/common/LuckyOrderIntro.vue'

export default {
  components: { LuckyOrderIntro },
  data() {
    return {
      isLoading: false,
      list: [],
      currentPage: 1,
      totalPages: 1,
      limit: 10,
      showOrderModal: false,
      showLuckyIntro: false,
      currentOrder: null,
      orderLoading: false,
      paypassword: '',
      hasPayPassword: false,
      paidOrderCount: 0,
      userBalance: '',
    };
  },

  computed: {
    luckyCommission() {
      if (!this.currentOrder || this.currentOrder.order_type !== 'card_order') return '';
      return this.currentOrder.commission || '';
    },
    needPayPasswordInput() {
      return false;
    },
    displayBalance() {
      return this.userBalance != null && this.userBalance !== '' ? this.userBalance : '';
    },
    orderTotal() {
      if (!this.currentOrder) return 0;
      return Number(this.currentOrder.total_amount || this.currentOrder.goods_price || 0);
    },
    orderShortfall() {
      const total = this.orderTotal;
      const bal = Number(this.userBalance || 0);
      const diff = Math.round((total - bal) * 100) / 100;
      return diff > 0 ? (Number.isInteger(diff) ? String(diff) : diff.toFixed(2)) : '';
    },
    showOrderShortfall() {
      if (!this.currentOrder || this.currentOrder.order_type !== 'card_order') return false;
      if (this.userBalance == null || this.userBalance === '') return false;
      return !!this.orderShortfall;
    },
  },

  methods: {
    back() {
      return window.history.back();
    },

    onRefresh() {
      this.getOrderHistory();
      setTimeout(() => {
        this.$toast(this.$t('请求.刷新成功'));
        this.isLoading = false;
      }, 500);
    },

    async getOrderHistory() {
      try {
        const result = await http({
          method: 'get',
          url: 'getOrderHistory',
          data: { page: this.currentPage, limit: this.limit }
        });

        if (result && result.code === 200) {
          if (result.data2 && result.data2.data) {
            this.list = result.data2.data || [];
            this.totalPages = result.data2.total_pages || 1;
          } else if (result.data && Array.isArray(result.data)) {
            this.list = result.data || [];
            this.totalPages = result.total_pages || 1;
          } else {
            this.list = [];
            this.totalPages = 1;
          }
        } else {
          this.$toast(result.msg || this.$t('订单历史.获取失败'));
        }
      } catch (error) {
        console.error('获取订单历史出错:', error);
        this.$toast(this.$t('订单历史.获取失败重试'));
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getOrderHistory();
      }
    },

    formatTime(timeStr) {
      if (!timeStr) return this.$t('订单历史.未知');
      if (typeof timeStr === 'string' && timeStr.includes('-')) return timeStr;
      if (typeof timeStr === 'number') {
        const date = new Date(timeStr * 1000);
        const p = v => String(v).padStart(2, '0');
        return `${date.getFullYear()}-${p(date.getMonth()+1)}-${p(date.getDate())} ${p(date.getHours())}:${p(date.getMinutes())}:${p(date.getSeconds())}`;
      }
      return timeStr;
    },

    openOrderModal(order) {
      if (!order || this.orderLoading) return;
      if (!this.hasPayPassword) {
        this.$toast(this.$t('订单历史.请先设置支付密码'));
        this.$router.push({ path: '/SetPayPassword' });
        return;
      }
      this.paypassword = '';
      this.currentOrder = order;
      if (order.order_type === 'card_order') {
        this.showLuckyIntro = true;
      } else {
        this.showOrderModal = true;
      }
    },

    onLuckyIntroDone() {
      this.showLuckyIntro = false;
      this.showOrderModal = true;
    },

    closeModal() {
      if (this.orderLoading) return;
      this.showOrderModal = false;
      this.showLuckyIntro = false;
      this.currentOrder = null;
      this.paypassword = '';
    },

    handleImageError(event) {
      event.target.style.display = 'none';
    },

    async confirmPlaceOrder() {
      if (!this.currentOrder || this.orderLoading) return;
      if (!this.hasPayPassword) {
        this.$toast(this.$t('订单历史.请先设置支付密码'));
        this.$router.push({ path: '/SetPayPassword' });
        return;
      }
      if (this.needPayPasswordInput && !this.paypassword) {
        this.$toast(this.$t('订单历史.请输入支付密码'));
        return;
      }

      this.orderLoading = true;
      try {
        const data = {
          order_id: this.currentOrder.id,
          quantity: this.currentOrder.quantity || 1,
        };
        if (this.needPayPasswordInput) {
          data.paypassword = this.paypassword;
        }
        const result = await http({
          method: 'post',
          url: 'placeOrder',
          data,
        });

        if (result && result.code === 200) {
          this.$toast.success(this.$t('订单历史.完成成功'));
          this.showOrderModal = false;
          this.showLuckyIntro = false;
          this.currentOrder = null;
          this.paypassword = '';
          this.paidOrderCount = this.paidOrderCount + 1;
          this.getOrderHistory();
        } else {
          this.$toast((result && result.msg) || this.$t('订单历史.完成失败'));
        }
      } catch (error) {
        console.error('完成订单出错:', error);
        this.$toast(this.$t('订单历史.完成失败重试'));
      } finally {
        this.orderLoading = false;
      }
    },

    async loadUserPayPasswordFlag() {
      try {
        const result = await http({ method: 'get', url: 'user_info' });
        if (result && result.code === 200 && result.data) {
          this.hasPayPassword = !!result.data.paypassword;
          this.userBalance = result.data.balance;
          const limit = result.data.daily_order_limit || {};
          this.paidOrderCount = Number(limit.today_raw || 0);
        }
      } catch (e) {
        // ignore
      }
    },
  },

  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.loadUserPayPasswordFlag();
      this.getOrderHistory();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 20px;
  margin: 20px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 15px;
  color: #f3c7a2;
  border: 1px solid #766350;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

// ── 订单头部 ──────────────────────────────────────────
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #766350;
}

.order-id .label {
  font-size: 22px;
  color: #9b9b9b;
}

.order-id .value {
  font-size: 22px;
  font-weight: 700;
  color: #f3c7a2;
  margin-left: 8px;
}

.order-status .status-success {
  color: #07c160;
  font-weight: 700;
  font-size: 22px;
}

.order-status .status-pending {
  color: #ff9500;
  font-weight: 700;
  font-size: 22px;
}

.order-status .status-cancelled {
  color: #ff3b30;
  font-weight: 700;
  font-size: 22px;
}

// ── 金额信息 ──────────────────────────────────────────
.amount-info {
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(118, 99, 80, 0.1);
  border-radius: 10px;
}

.amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  &:last-child { margin-bottom: 0; }
}

.amount-row .label {
  font-size: 22px;
  color: #9b9b9b;
}

.amount-row .value {
  font-size: 24px;
  font-weight: 700;
  color: #f3c7a2;
}

.amount-row .commission {
  color: #07c160;
}

// ── 时间信息 ──────────────────────────────────────────
.time-info {
  padding-top: 15px;
  border-top: 1px solid #766350;
}

.time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  &:last-child { margin-bottom: 0; }
}

.time-row .label {
  font-size: 20px;
  color: #9b9b9b;
}

.time-row .value {
  font-size: 20px;
  color: #f3c7a2;
}

// ── 完成订单按钮 ──────────────────────────────────────
.complete-order-btn-inline {
  background: linear-gradient(120deg, #07c160, #059669);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 22px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &:active { transform: translateY(0); }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #212121;
  border-radius: 20px;
  width: 100%;
  max-width: 600px;
  border: 1px solid #766350;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  position: relative;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 36px;
  border-bottom: 1px solid #333;

  h3 {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
    color: #e6b98a;
  }
}

.close-btn {
  background: #333;
  border: 1px solid #555;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.modal-body {
  padding: 24px 36px;
}

.modal-footer {
  padding: 24px 36px;
  border-top: 1px solid #333;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.order-time,
.order-number {
  display: flex;
  align-items: center;
  gap: 12px;
}

.time-label,
.number-label {
  font-size: 24px;
  color: #999;
  font-weight: 500;
  white-space: nowrap;
}

.time-value,
.number-value {
  font-size: 26px;
  color: #e6b98a;
  font-weight: 600;
}

.goods-card {
  display: flex;
  gap: 20px;
  padding: 20px;
  background: #2a2a2a;
  border-radius: 12px;
  border: 1px solid #444;
}

.goods-image-section {
  flex: 0 0 100px;
}

.goods-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #555;
}

.goods-info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.goods-name {
  font-size: 26px;
  color: #fff;
  font-weight: 600;
  line-height: 1.4;
}

.amount-summary {
  padding: 20px;
  background: #2a2a2a;
  border-radius: 12px;
  border: 1px solid #444;
}

.modal-amount-row {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.amount-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.amount-label {
  font-size: 24px;
  color: #999;
  font-weight: 500;
}

.amount-value {
  font-size: 28px;
  color: #fff;
  font-weight: 700;
}

.commission-value {
  font-size: 28px;
  color: #f97316;
  font-weight: 700;
}

.pay-password-wrap {
  margin-top: 8px;
}

.pay-password-input {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 24px;
  font-size: 28px;
  color: #f3c7a2;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 12px;
  outline: none;

  &::placeholder {
    color: #766350;
  }

  &:focus {
    border-color: #766350;
  }

  &:disabled {
    opacity: 0.6;
  }
}

.place-order-btn {
  flex: 1;
  background: linear-gradient(to right, #efcba7, #dcab76);
  color: #68302c;
  border: none;
  border-radius: 12px;
  padding: 20px 36px;
  font-size: 28px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    background: #444;
    color: #666;
    cursor: not-allowed;
  }
}

.cancel-btn {
  background: #2a2a2a;
  color: #999;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 20px 36px;
  font-size: 28px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// ── 分页 ──────────────────────────────────────────────
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 30px 0;
  padding: 20px;
}

.page-btn {
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  color: #f3c7a2;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 22px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.page-info {
  font-size: 22px;
  color: #f3c7a2;
  font-weight: 700;
}

// ── 移动端适配 ────────────────────────────────────────
@media (max-width: 768px) {
  .item_list {
    padding: 15px;
    margin: 15px 5px;
  }

  .order-id .value,
  .order-id .label     { font-size: 22px; }

  .amount-row .value,
  .amount-row .label   { font-size: 22px; }

  .time-row .value,
  .time-row .label     { font-size: 20px; }

  .page-btn            { font-size: 20px; }
  .page-info           { font-size: 20px; }
}
</style>